<template>
  <div :class="containerClass">
    <div :class="className">
      <div class="b-portlet-header" v-if="title">
        <div class="subtitle is-4 has-text-primary">{{ title }}</div>
      </div>
      <div class="b-portlet-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BContainer',
  props: {
    title: String,
    background: String,
    containerClass: { type: String, default: 'section' }
  },
  data() {
    return {
      className: 'b-portlet'
    }
  },
  mounted() {
    if (this.background) {
      this.className = `${this.className} has-background-${this.background}`
    }
  }
}
</script>
